<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Bf26yf/tc-custom/9781955835091.jpg?1705261440494" alt="This image is the cover for the book Imaging Russia 2000"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Imaging Russia 2000
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] sparkling and original work . . . I can think of no better guide to the heart of post-Soviet urban Russia than this entertaining and refreshing book.” —Richard Stites, Professor of History, Georgetown University</b><br/><br/>This book incorporates into an organic whole the realities of the 1990s in Russia, focusing on film production, the films themselves, and the socio-political-cultural context. It aims to provide a picture of Russia (with Moscow in the foreground) as the big stage on which the drama unfolded. The author discusses some eighty films made between 1990 and 2000. Many reflect the reality of the present day, either in dramatic or grotesque form. Others reassess the past, placing different spins on various epochs and figures according to the director’s ideological orientation. Still others offer escapism into imaginary worlds. The films selected may vary in technical quality and depth of thought; they may be mainstream pictures, or art films. But taken together, they provide an eloquent portrait of Russia, entering the new millennium still in search of its true identity.<br/><br/><b>A <i>Choice</i> Outstanding Academic Title</b><br/><br/>“Anna Lawton deftly tells two stories—one about the evolution of Russian film since the collapse of the Soviet Union in 1991, and the other about Russian life during that same period. She managed to capture a vivid portrait of Moscow of the 1990s, and to remind us that the Soviet past remains omnipresent in the new Russia . . . a must read for anyone who cares about Russia, or about film.” —Blair Ruble, Director, The Kennan Institute of the Woodrow Wilson Center
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Lawton
      </h2>
      
      <p class="authorDescription body article">Dr. Anna Lawton is a specialist in Russian film and culture. She teaches courses in visual culture and film studies at Georgetown University. Her publications include:  Imaging Russia 2000: Film and Facts  (2004);  Before the Fall: Soviet Cinema in the Gorbachev Years  (2004);  The Red Screen: Politics, Society, Art in Soviet Cinema  (1992); and numerous journal articles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Academia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bb8349fe